import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, getPostData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';
import { DateRange } from 'react-day-picker';

import { PUR6010_R01DetailDto, PUR6010_R01Dto, PUR6010_R01HeaderDto, } from './Dto_PUR6010_R01';
import { PUR6010_R01Filter } from "./Store_PUR6010_R01";

const baseUrl = `${config.apiUrl}/PUR6010_R01`;

const getParams = (filter: Partial<PUR6010_R01Filter>, listLength?: number) => {	
	return {
		paymentDateRange: filter.paymentDateRange ? formatDate(filter.paymentDateRange.from) : undefined,
			startDate: filter.paymentDateRange ? formatDate(filter.paymentDateRange.from) : undefined,
			endDate: filter.paymentDateRange ? formatDate(filter.paymentDateRange.to) : undefined,
		tradeDateRange: filter.tradeDateRange ? formatDate(filter.tradeDateRange.from) : undefined,
			tradeStartDate: filter.tradeDateRange ? formatDate(filter.tradeDateRange.from) : undefined,
			tradeEndDate: filter.tradeDateRange ? formatDate(filter.tradeDateRange.to) : undefined,
		customCd: filter.customCd || undefined,
		customNm: filter.customNm || undefined,
		compCd: filter.compCd || undefined,
		compNm: filter.compNm || undefined,
		tradeType: filter.tradeType || undefined,
		listLength: listLength || 0
	}
}

export const getPUR6010_R01List = async (option: string, params: Partial<PUR6010_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PUR6010_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR6010_R01AllCount = async (params: Partial<PUR6010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}	

export const getPUR6010_R01One = async (tradeNo: string) => {
	const url = `${baseUrl}/one/${tradeNo}`;
	return await getData<ResponseDto<PUR6010_R01HeaderDto>>(url);
}

export const getPUR6010_R01DetailList = async (tradeNo: string) => {
	const url = `${baseUrl}/detail/${tradeNo}`;

	return await getData<ResponseDto<PUR6010_R01DetailDto[]>>(url);
}

export const getPUR6010_R01CreateDetailList = async (customCd: string, tradeDateRange?: DateRange) => {
	const url = `${baseUrl}/createDetail`;

	return await getData<ResponseDto<PUR6010_R01DetailDto[]>>(url, {
		params: {
			customCd,
			startDate: tradeDateRange?.from ? formatDate(tradeDateRange.from) : undefined,
			endDate: tradeDateRange?.to ? formatDate(tradeDateRange.to) : undefined,
		},
	});
}

export const patchPUR6010_R01 = async (data: PUR6010_R01Dto, ) => {

	const url = `${baseUrl}`;

	return await patchData<PUR6010_R01Dto, ResponseDto<PUR6010_R01Dto[]>>(url, {
		...data,
	});
}

export const postPUR6010_R01 = async (data: PUR6010_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<PUR6010_R01Dto, ResponseDto<PUR6010_R01Dto[]>>(url, data);
}

export const deletePUR6010_R01 = async (paymentNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<PUR6010_R01Dto>>(url, {
		params: {
			paymentNo
		}
	});
}

export const downloadExcel_PUR6010_R01 = async (option: string, tradeNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			tradeNo
		}
	})
}